
export const getDodDiff = (metricTotal, dodTotal) => {
  const trend = dodTotal ? (metricTotal - dodTotal) / dodTotal : null;
  return trend;
}
